// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__OHkyn","selected":"Tag_selected__VcBNl","disabled":"Tag_disabled__qgAVO","opaque":"Tag_opaque__5sLGX","skeleton":"Tag_skeleton__7CmkJ"};